import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

const FieldCell = ({ value }) => {
  const [collapsed, setCollapsed] = useState(true);

  if (!value) return null;

  return (
    <div>
      <Button
        size="sm"
        variant="link"
        className="px-0"
        onClick={() => setCollapsed(prev => !prev)}
      >
        {collapsed ? 'Show' : 'Hide'}
      </Button>
      {!collapsed && (
        <div className="mt-2">
          {Object.entries(value).map(([key, val]) => (
            <div key={key} className="mb-1">
              <strong>{key}:</strong>{' '}
              {typeof val === 'object' && val !== null
                ? <pre className="mb-0" style={{ whiteSpace: 'pre-wrap' }}>{JSON.stringify(val, null, 2)}</pre>
                : String(val)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FieldCell;
